<ridango-ticket
    *ngFor="let ticket of tickets"
    [ticket]="ticket"
    [embeddedQR]="true"
    [actions]="actions"
    [useInputActions]="useInputActions"
    [locale]="locale"
    [hasZoneModal]="ticket?.start_zone || ticket?.start_zone_name ? true : false"
    [assetsPath]="assetsPath$ | async"
    [useActiveValidationText]="true"
    (requestTicketAction)="ticketAction($event)">
</ridango-ticket>
